import { useCallback, useEffect } from 'react';
import { debounce as debounceFn } from 'throttle-debounce';

function useOnIdle({ debounce, events, onAction, onIdle, idleTimeout, stop }) {
  const actionCallBack = useCallback(debounceFn(debounce, true, onAction), []);
  const idleCallBack = useCallback(debounceFn(idleTimeout, false, onIdle), []);

  const removeListeners = useCallback(() => {
    events.forEach((event) => {
      document.removeEventListener(event, actionCallBack);
      document.removeEventListener(event, idleCallBack);
    });
  }, [events, actionCallBack, idleCallBack]);

  useEffect(() => {
    if (!stop) {
      events.forEach((event) => {
        document.addEventListener(event, actionCallBack);
        document.addEventListener(event, idleCallBack);
      });
    }
    return removeListeners;
  }, [stop, events, actionCallBack, idleCallBack, removeListeners]);

  return { removeListeners };
}

export default useOnIdle;
